export default __webpack_public_path__ + "static/media/cold-brewed-iced-coffee.cc8f8a62.png";